import { Game } from '../models/Game';

const invitationGameSlug = 'lets-crossword';
const invitationParam = 'roomid';

export class InvitaionService {
    public static isInvitaionLink (game: Game) {
        if (game.slug === invitationGameSlug) {
            const search = new URLSearchParams(window.location.search);
            if (search.get(invitationParam)) {
                return true;
            }
        }
        return false;
    }
}
